import AnalyticsEvent from './analytics-event';
import { ProductProperty, createProductProperty } from '../properties/product-property';
import { BrandProperty, createBrandProperty } from '../properties/brand-property';
import { CartProperty, createCartProperty } from '../properties/cart-property';

export default class ProductAddedToCartEvent extends AnalyticsEvent {
  public readonly name = 'Product Added to Cart';
  public properties: {
    product: ProductProperty;
    quantity: number;
    brand: BrandProperty;
    cart: CartProperty;
    id_section: string | null;
    // Whether the discount filter or "sort by discount" was active on the catalog page this add
    // originated from - not the checkout-completion leg of the funnel, that needs a backend
    // change to survive the checkout page's full server reload (tracked as a follow-up ticket).
    discount_intent: 'filter' | 'sort' | null;
  };

  constructor(
    product: ProductProperty,
    quantity: number,
    brand: BrandProperty,
    cart: CartProperty,
    sectionId = null,
    discountIntent: 'filter' | 'sort' | null = null
  ) {
    super();
    this.properties = {
      product: createProductProperty(product),
      quantity: quantity,
      brand: createBrandProperty(brand),
      cart: createCartProperty(cart),
      id_section: sectionId,
      discount_intent: discountIntent,
    };
  }
}
